import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.hash.substring(1));
    const sessionId = params.get("session_id");

    const exchange = async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } });
        setUser(data.user);
        // Clear the hash and land on the dashboard.
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (err) {
        const status = err?.response?.status;
        window.history.replaceState(null, "", window.location.pathname);
        if (status === 403) {
          navigate("/login?error=unauthorised", { replace: true });
        } else {
          navigate("/login", { replace: true });
        }
        // eslint-disable-next-line no-console
        console.error("Auth error:", formatApiError(err));
      }
    };
    exchange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6]">
      <div className="text-[#5C5652] text-xs uppercase tracking-[0.3em]">Signing you in…</div>
    </div>
  );
}
